import { render, staticRenderFns } from "./AccountRemoveModal.vue?vue&type=template&id=1013421b"
import script from "./AccountRemoveModal.vue?vue&type=script&lang=js"
export * from "./AccountRemoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports